// store.js
import { configureStore } from "@reduxjs/toolkit";
import realtimeSlice from "./slice/realtimeSlice";
import ipCamSlice from "./slice/ipCamSlice";
import masterSlice from "./slice/masterSlice";
import notifikasiSlice from "./slice/notifikasiSlice";
import videoSlice from "./slice/videoSlice";
import mediaMTXSlice from "./slice/mediaMTXSlice";
import checkMediaMTXSlice from "./slice/checkMediaMTXSlice";
import videoPathSlice from "./slice/videoPathSlice";
import videoResponseSlice from "./slice/videoResponseSlice";
import playbackSlice from "./slice/playbackSlice";
import reportSlices from "./slice/reportSlices";
import searchImage from "slice/searchSlice";
import jurisdictionSlice from "slice/jurisdictionSlice";
import targetSlice from "slice/targetSlice";
import statusNatsSlice from "slice/statusNatsSlice";
import allTargetSlice from "slice/allTargetSlice";
import targetIsDpoSlice from "slice/targetIsDpoSlice";
import streamingBackgroundGetListSlice from "slice/streamingBackgroundGetListSlice";
import streamingBackgroundGetImageStreamingSlice from "slice/streamingBackgroundGetImageStreamingSlice";
import streamingBackgroundGetImagePersonFaceSlice from "slice/streamingBackgroundGetImagePersonFaceSlice";

const store = configureStore({
  reducer: {
    notifikasi: notifikasiSlice,
    master: masterSlice,
    realtime: realtimeSlice,
    ipCam: ipCamSlice,
    mediaMTX: mediaMTXSlice,
    checkMediaMTX: checkMediaMTXSlice,
    playback: playbackSlice,
    report: reportSlices,
    search: searchImage,
    videoList: videoSlice,
    videoPath: videoPathSlice,
    videoResponse: videoResponseSlice,
    jurisdiction: jurisdictionSlice,
    statusNats: statusNatsSlice,
    target: targetSlice,
    targetIsDpo: targetIsDpoSlice,
    allTarget: allTargetSlice,
    streamingBackgroundGetList: streamingBackgroundGetListSlice,
    streamingBackgroundGetImageStreaming:
      streamingBackgroundGetImageStreamingSlice,
    streamingBackgroundGetImagePersonFace:
      streamingBackgroundGetImagePersonFaceSlice,
  },
});

export default store;
